export default "__VITE_ASSET__BUtQ3$jh__"